import shopeeImg from '@/assets/img/platforms/shopee.png'
import lazadaImg from '@/assets/img/platforms/lazada.png'
import facebookImg from '@/assets/img/platforms/facebook.png'
import wooImg from '@/assets/img/platforms/woo.png'
import TiktokImg from '@/assets/img/platforms/tiktok.png'
import lineImg from '@/assets/img/platforms/line.png'
import lineShoppingImg from '@/assets/img/platforms/lineshopping.png'
import shopifyImg from '@/assets/img/platforms/shopify.png'
import instagramImg from '@/assets/img/platforms/instagram.png'
import facebookliveImg from '@/assets/img/platforms/facebooklive.png'
import igliveImg from '@/assets/img/platforms/iglive.png'
import LineOAImg from '@/assets/img/platforms/LineOA.png'
import websiteImg from '@/assets/img/platforms/website.png'
import salepageImg from '@/assets/img/platforms/salepage.png'
import resellerImg from '@/assets/img/platforms/reseller.png'
import phoneImg from '@/assets/img/platforms/phone.png'
import bagImg from '@/assets/img/platforms/bag.jpg'
import twitterImg from '@/assets/img/platforms/twitter.png'
import posImg from '@/assets/img/platforms/ppos.png'
import moreImg from '@/assets/img/platforms/more.png'

export default [
  {
    value: null,
    text: '-'
  },
  {
    text: 'Shopee',
    value: 'SHOPEE',
    image: shopeeImg
  },
  {
    text: 'Lazada',
    value: 'LAZADA',
    image: lazadaImg
  },
  {
    text: 'Facebook',
    value: 'FACEBOOK',
    image: facebookImg
  },
  {
    text: 'Instagram',
    value: 'INSTAGRAM',
    image: instagramImg
  },
  {
    text: 'Twitter',
    value: 'TWITTER',
    image: twitterImg
  },
  {
    text: 'Facebook Live',
    value: 'FACEBOOK_LIVE',
    image: facebookliveImg
  },
  {
    text: 'Instagram Live',
    value: 'INSTAGRAM_LIVE',
    image: igliveImg
  },
  {
    text: 'line',
    value: 'LINE',
    image: lineImg
  },
  {
    text: 'line OA',
    value: 'LINE_OA',
    image: LineOAImg
  },
  {
    text: 'Woocommerce',
    value: 'WOOCOMMERCE',
    image: wooImg
  },
  {
    text: 'Sale Page',
    value: 'SALE_PAGE',
    image: salepageImg
  },
  {
    text: 'Website',
    value: 'WEBSITE',
    image: websiteImg
  },
  {
    text: 'Tiktok',
    value: 'TIKTOK',
    image: TiktokImg

  },
  {
    text: 'Line Shopping',
    value: 'LINE_SHOPPING',
    image: lineShoppingImg
  },
  {
    text: 'Shopify',
    value: 'SHOPIFY',
    image: shopifyImg
  },
  {
    text: 'ตัวแทนจำหน่าย',
    value: 'RESELLER',
    image: resellerImg
  },
  {
    text: 'โทรศัพท์',
    value: 'PHONE',
    image: phoneImg
  },
  {
    text: 'Shopping Link',
    value: 'SHOPPING_LINK',
    image: bagImg
  },
  {
    text: 'หน้าร้าน',
    value: 'POS',
    image: posImg
  },
  {
    text: 'อื่นๆ',
    value: 'OTHER',
    image: moreImg
  }
]
